import React from 'react';

import ImportColumnLayout from '../layout/ImportColumnLayout';
import GridList, { type IAction } from '../controls/GridList';
import { AcademicCapIcon } from '@heroicons/react/24/outline';

export default function SupportPage() {
  const actions: IAction[] = [
    {
      title: 'DataOps.live Docs',
      desc: 'Learn more about using DataOps.live.',
      onClick: (action, actionIdx) => {
        window.open('https://docs.dataops.live/docs/get-started/', '_blank');
      },
      icon: AcademicCapIcon,
      iconForeground: 'sky-700',
      iconBackground: 'sky-50',
      eventPayload: {
        name: 'help-dataopslive-docs-start',
      },
    },
  ];

  return (
    <ImportColumnLayout>
      <GridList actions={actions} />
    </ImportColumnLayout>
  );
}
